import React from 'react'
import { AppSelectionBar, AppSelectionBarButton } from "@components"
import useMultipleActions from "Pages/User/CustomMapping/Table/@hooks/useMultiple"
import { bulkFieldModal } from "Pages/User/CustomMapping/@signals"


export default function CustomMappingToolbarSelect({ selectedData, setSelectedRows, path }) {
	const { handleRemoveMultipleMappings, isLoadingDelete } = useMultipleActions(selectedData, setSelectedRows, path)

	const openBulkModal = field => {
		bulkFieldModal.value = { field, path, values: [], rows: selectedData }
	}

	return <AppSelectionBar count={selectedData?.length || 0} onClear={() => setSelectedRows([])}>
		<AppSelectionBarButton icon="flag" label="Countries" title="Edit Countries for Multiple Mappings" onClick={() => openBulkModal('countries')}/>
		<AppSelectionBarButton icon="building" label="Offices" title="Edit Offices for Multiple Mappings" onClick={() => openBulkModal('offices')}/>
		<AppSelectionBarButton icon="globe-pointer" label="Sites" title="Edit Sites for Multiple Mappings" onClick={() => openBulkModal('sites')}/>
		<AppSelectionBarButton icon="handshake" label="Providers" title="Edit Providers for Multiple Mappings" onClick={() => openBulkModal('providers')}/>
		<AppSelectionBarButton
			icon="trash"
			label={isLoadingDelete ? 'Deleting…' : 'Delete'}
			title="Delete multiple mappings"
			danger
			disabled={!!isLoadingDelete}
			onClick={handleRemoveMultipleMappings}
		/>
	</AppSelectionBar>
}